import { render } from "./GatewayDetail.vue?vue&type=template&id=cf059356"
import script from "./GatewayDetail.vue?vue&type=script&lang=js"
export * from "./GatewayDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__